import React, { useEffect, useContext, useState, useRef } from 'react'
import PropTypes from 'prop-types'

import Snowplow from '@cred/react-analytics/Snowplow'
import {
  withSnowplowContexts,
  SnowplowReactContext,
} from '@cred/react-analytics/SnowplowContextManager'

import WidgetContext from 'components/widget-context'
import { fireGtmEvent } from 'utils/gtm'
import useViewportAnalytics from 'common/hooks/useViewportAnalytics'

const ViewportAnalytics = ({ trackSnowplowEvent, size, children }) => {
  const viewportRef = useRef(null)
  const widgetContext = useContext(WidgetContext)
  const snowplowContext = useContext(SnowplowReactContext)
  const [pageviewFired, setPageviewFired] = useState(false)

  useViewportAnalytics({
    ref: viewportRef,
    contexts: widgetContext,
    trackSnowplowEvent,
  })

  useEffect(() => {
    // Wait for the widget size data and fire only once
    if (size.h && !pageviewFired) {
      setPageviewFired(true)
      Snowplow.trackPageView(document.title, snowplowContext, {
        pageUrl: window.location.href,
        referrerUrl: document.referrer,
        shouldActivateExperimentContext: false,
      })
      fireGtmEvent('pageview', widgetContext)
    }
  }, [size.h, pageviewFired, snowplowContext, widgetContext])

  return <div ref={viewportRef}>{children}</div>
}

ViewportAnalytics.propTypes = {
  size: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default withSnowplowContexts(ViewportAnalytics)
